
import React from "react";
import { Settings } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
  SheetClose,
  SheetFooter,
} from "@/components/ui/sheet";
import { NotificationSettings } from "./NotificationSettings";

interface PointageHeaderProps {
  currentDate: string;
  notificationsEnabled: boolean;
  setNotificationsEnabled: (enabled: boolean) => void;
  reminderSettings: {
    morningReminder: boolean;
    morningReminderTime: string;
    eveningReminder: boolean;
    eveningReminderTime: string;
    smartNotifications: boolean;
  };
  onReminderSettingChange: (setting: string, value: any) => void;
  isOffline: boolean;
}

export const PointageHeader: React.FC<PointageHeaderProps> = ({
  currentDate,
  notificationsEnabled,
  setNotificationsEnabled,
  reminderSettings,
  onReminderSettingChange,
  isOffline
}) => {
  return (
    <header className="bg-gray-800 text-white px-4 py-3 fixed w-full top-0 z-50">
      <div className="flex items-center justify-between">
        <h1 className="text-lg font-bold">Pointage de la journée</h1>
        <div className="flex items-center space-x-2">
          <div className="text-sm">{currentDate}</div>
          
          {/* Sheet for settings */}
          <Sheet>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" className="text-white">
                <Settings className="h-5 w-5" />
              </Button>
            </SheetTrigger>
            <SheetContent>
              <SheetHeader>
                <SheetTitle>Paramètres</SheetTitle>
                <SheetDescription>
                  Configurez vos paramètres de pointage et de notifications intelligentes.
                </SheetDescription>
              </SheetHeader>
              
              <NotificationSettings
                notificationsEnabled={notificationsEnabled}
                setNotificationsEnabled={setNotificationsEnabled}
                reminderSettings={reminderSettings}
                onReminderSettingChange={onReminderSettingChange}
                isOffline={isOffline}
              />
              
              <SheetFooter>
                <SheetClose asChild>
                  <Button className="w-full">Fermer</Button>
                </SheetClose>
              </SheetFooter>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
